import React from 'react';

const ProductStructure = () => {
  return (
    <iframe
      src="https://iframe.krgsc.kz/product-structure"
      title="product-structure"
      style={{ border: 'none' }}
      width="100%"
      height="100%"
    />
  );
};

export default ProductStructure;
